import { parseEventDate } from '../dateTimeUtils';

/**
 * Filter an already-expanded event list down to those whose LOCAL start date
 * matches a target day, dropping archived + cancelled occurrences. Extracted
 * verbatim from EventListModule's inline `getEventsForDate` closure (the
 * captured `expandedEvents` array is now an explicit first argument so the
 * helper is pure). Behavior is pinned by `eventsForDate.char.test.ts`.
 */
export function getEventsForDate<T extends { archived?: boolean; cancelledOccurrence?: boolean; startAt: unknown }>(
  expandedEvents: T[],
  date: Date,
): T[] {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  return expandedEvents.filter((event) => {
    if (event.archived || event.cancelledOccurrence) return false;

    const eventDate = parseEventDate(event.startAt);
    if (!eventDate) return false;

    return eventDate.getFullYear() === year &&
           eventDate.getMonth() === month &&
           eventDate.getDate() === day;
  });
}
